<template>
	<div>
		<div class="row">
			<div class="col-md-8">
				<div class="row">
					<div class="col-md-6 ">
						<sequential-entrance>
						<ListCompare title="SALES" unit="KL" comp=1 :data="ytd.sales" itemcol="Info" valuecol="Value"
							:url="'/fuel/report2?tab=0&' + this.getYTDfilter('dateStart', 'dateEnd')"/>
						</sequential-entrance>
					</div>
					<div class="col-md-6 ">
						<ListCompare title="LOSSES" unit="%" comp=-1 :data="ytd.losses" itemcol="Info" valuecol="Value"
							:url="'/fuel/report2?tab=1&' + this.getYTDfilter('dateStart', 'dateEnd')"/>
					</div>
				</div>
				<div class="mb-4">
					<BarCard title="SALES WEEKLY (KL)" :data="sales.weekly" :width="500" :height="400" v-if="showchartfuel"/>
				</div>
				<div class="row">
					<div class="col-md-6">
					<div class="card cardptpr mb-4">
						<div class="card-header cardptpr p-3 pb-0 pt-0">
							<H6>PAYMENT YTD (B)</H6>
						</div>
						<div class="card-body p-3 px-2" style="width:280px;">
							<PieChart :data="this.pieChartDataPayment" 
								:url="'/fuel/report2?tab=2&' + this.getYTDfilter('dateStart', 'dateEnd')"/>
                        </div>
                    </div>
                    </div>
					<div class="col-md-6">
						<ListCompare title="CASH PERCENTAGE" unit="%" comp=-1 :data="ytd.pctcash" itemcol="Info" valuecol="Value"
							:url="'/fuel/report2?tab=2&' + this.getYTDfilter('dateStart', 'dateEnd')"/>
                    </div>
				</div> 
			</div>
			<div class="col-md-4 mb-4">
				<div class="mb-4">
					<ListCompare title="REALISASI BBK" unit="%" comp=1 :data="ytd.bbk" itemcol="Info" valuecol="Value"
						:url="'/fuel/report2?tab=0&detail2=group&' + this.getYTDfilter('dateStart', 'dateEnd')"/>
				</div>
				<div class="">
					<ListItem class=" mb-4" warning=1 title="CRITICAL STOCK BY PRODUCT" :data="critical.product" itemcol="ProductName" valuecol="Cnt"
						url="/fuel/report2?tab=3&status=CRITICAL&detail2=product"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import { Config,Penanggalan,AxiosWithJar, FuelColor, Rainbow, Rainbow2 } from '@/utility.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'

export default{
	extends: Fuel,
	components:{
		ListItem,
		ListCompare,
		BarCard,
		PieChart,
		//Footer            
	},
	props: {
        plant: {
            type: String,
            default: '',
            //required: false,
        },
        station: {
            type: String,
            default: '',
            //required: false,
        },
		showchartfuel: {
			type: Boolean,
			default: false,
		},
    },

	data() {
		return {
			//station: this.stationid,
			//dataid: this.station,

			spbu:{ data:{}, list:[], types:[] },
			sales: {hourly:[], weekly:[], lastTrans:[]},
			ytd: {raw:{}, sales:[], losses:[], bbk:[], cash:[], noncash:[], pctcash:[],rekap:[],},
			stock:{ tank:[] },
			critical:{product:[], area:[]},
			
            pieChartDataPayment : [],
		}
	},

	watch : {
		station(newVal, oldVal) {
			//console.log('watch new station id: ' + this.station);
			//console.log('watch old station id: ' + oldVal);
			this.loadYTD();
			this.loadSalesYTD();
			this.loadCritical();
		},
		ytd() {
			this.setPieChartDataPayment();
		},
		dataid() {
			//console.log('dataid: ' + this.dataid);
		}
		
	},

	computed:{
		
	},

    mounted() {
		//this.loadYTD();
		//this.loadSalesYTD();
		//this.loadCritical();

		//this.loadStationList();
		//this.loadStationTypes();

    },
    methods:{
        setPieChartDataPayment() {
			var warna=[]
			warna["NON CASH"]='rgba(255,0,0,1)'
			warna["CASH"]='rgba(0,0,255,1)'				

			let result =  this.processPieChart(
				[{
					transtype: "CASH", 
					amount: this.getYTDItem(this.ytd.raw.cash, 1).AmountCash
				},
				{
					transtype: "NON CASH", 
					amount: this.getYTDItem(this.ytd.raw.cash, 1).AmountNonCash
				}], 
				"amount", "transtype", 1000000000, 2, warna); 
			this.pieChartDataPayment = result;
        },

		async loadYTD(){
			let url = Config().apiURL+ "/fuel2/ytd?" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data){
					this.ytd = {
						raw: result.data,
						sales: this.processYTD(result.data.summary, "Info", "SalesVolume", false, "Grup", 1000, 0),
						losses: this.processYTD(result.data.summary, "Info", "LossesVolume", "SalesVolume", "Grup", 0.01, 2),
						bbk: this.processYTD(result.data.summary, "Info", "SalesVolumeBBK", "SalesVolumeAll", "Grup", 0.01, 2),
						cash: this.processYTD(result.data.cash, "Info", "AmountCash", false, "Grup", 1, 2),
						noncash: this.processYTD(result.data.cash, "Info", "AmountNonCash", false, "Grup", 1, 2),
						pctcash: this.processYTD(result.data.cash, "Info", "AmountCash", "AmountAll", "Grup", 0.01, 2),
						rekap: this.processYTD(result.data.unit, "Info", "TotalUnit", false, "Grup", 1, 2),
					};

					
				}
			})
		},

		async loadSalesYTD(){
			let url =Config().apiURL+"/fuel2/sales?period=daily&detail=product"
				url += "&date-range-start="+Penanggalan().mingguSekarang
				url += "&date-range-end="+Penanggalan().kemarin
				url += (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.sales.weekly = this.processBarChart2(result.data.data, 'ProductName', 'SalesVolume', false, 'Period', 1000, 2, FuelColor, 
						false, false, false, true, false, false, false, true);

					this.redrawChart();
				}
			})
		},

		async loadCritical(satgas=0){			
			let url =Config().apiURL+"/fuel2/stock?satgas=" +satgas +"&status=CRITICAL&detail=product" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.critical.product = result.data.data;
				}
			})
			url =Config().apiURL+"/fuel2/stock?status=CRITICAL&detail=area" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.critical.area = result.data.data;
				}
			})
		},

		redrawChart() {
            this.showchartfuel = false
            setTimeout(() => {
                this.showchartfuel = true
                //console.log('Redraw chart growth')
            }, 500);
        },

	}
}
</script>